import React, { Component } from 'react'
import CheckLoginStatus from '../../conditions/CheckLoginStatus'
import WithPatient from '../../conditions/WithPatient'
import SessionLayout from '../../layouts/SessionLayout'
import LearnSession123 from './LearnSession123'

export default class Learn extends Component {
  render() {
    const { match } = this.props
    const { session, patientID } = match.params

    return (
      <CheckLoginStatus loggedOutRedirect="/">
        <WithPatient patientID={patientID}>
          <SessionLayout title="titles.learn">
            <LearnSession123 session={session} />
          </SessionLayout>
        </WithPatient>
      </CheckLoginStatus>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/Learn/index.js